var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mobile-quick-service", style: _vm.cssVars },
    [
      _c("div", { staticClass: "mobile-section-title" }, [_vm._v("快捷服务")]),
      _vm._v(" "),
      _vm.navList.length > 0
        ? _c(
            "div",
            {
              staticClass: "mobile-quick-service__hero",
              on: {
                click: function ($event) {
                  return _vm.handleClick(_vm.navList[0])
                },
              },
            },
            [
              _c("img", {
                staticClass: "mobile-quick-service__hero-bg",
                attrs: { src: _vm.getBgImg(0), alt: "" },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "mobile-quick-service__hero-overlay" }, [
                _c("div", { staticClass: "mobile-quick-service__hero-title" }, [
                  _vm._v(_vm._s(_vm.navList[0].name)),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mobile-quick-service__hero-stats" },
                  _vm._l(
                    _vm.navList[0].resourceTypeTotal,
                    function (child, ci) {
                      return _c(
                        "div",
                        {
                          key: ci,
                          staticClass: "mobile-quick-service__hero-stat",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "mobile-quick-service__hero-num" },
                            [_vm._v(_vm._s(child.total))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mobile-quick-service__hero-label" },
                            [_vm._v(_vm._s(child.name))]
                          ),
                        ]
                      )
                    }
                  ),
                  0
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.navList.length > 1
        ? _c(
            "div",
            { staticClass: "mobile-quick-service__grid" },
            _vm._l(_vm.navList.slice(1), function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "mobile-quick-service__card",
                  on: {
                    click: function ($event) {
                      return _vm.handleClick(item)
                    },
                  },
                },
                [
                  _c("img", {
                    staticClass: "mobile-quick-service__card-bg",
                    attrs: { src: _vm.getBgImg(index + 1), alt: "" },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mobile-quick-service__card-overlay" },
                    [
                      _c(
                        "div",
                        { staticClass: "mobile-quick-service__card-title" },
                        [_vm._v(_vm._s(item.name))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mobile-quick-service__card-num" },
                        [_vm._v(_vm._s(_vm.getTotalCount(item)))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mobile-quick-service__card-desc" },
                        [_vm._v("课程数量")]
                      ),
                    ]
                  ),
                ]
              )
            }),
            0
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }